export default {
  series: [
    {
      type: "gauge",
      radius: "100%",
      axisLine: {
        lineStyle: {
          width: 8,
          color: [
            [0.3, "#67e0e3"],
            [0.7, "#37a2da"],
            [1, "#fd666d"],
          ],
        },
      },
      pointer: {
        itemStyle: {
          color: "auto",
        },
        width: 2,
        length: "50%",
      },
      axisTick: {
        distance: -8,
        length: 4,
        lineStyle: {
          color: "#2088B8",
          width: 0.5,
        },
      },
      splitLine: {
        distance: -8,
        length: 8,
        lineStyle: {
          color: "#2088B8",
          width: 1,
        },
      },
      axisLabel: {
        color: "inherit",
        distance: 15,
        fontSize: 6,
      },
      detail: {
        fontSize: 15,
        valueAnimation: true,
        formatter: "{value} %",
        color: "inherit",
      },
      data: [
        {
          value: 70,
        },
      ],
    },
  ],
  graphic: [{}],
}
